// src/data/dossierCatalog.js
import { normalizeDossierMode, DOSSIER_MODES } from "./dossierModes.js";
// Catálogo para las vistas por BLOC (usa rutas absolutas /dossier/...)

const extToType = (path = "") => {
  const p = path.toLowerCase();
  if (p.endsWith(".pdf")) return "pdf";
  if (p.endsWith(".mp4") || p.endsWith(".webm")) return "video";
  if (p.endsWith(".png") || p.endsWith(".jpg") || p.endsWith(".jpeg") || p.endsWith(".webp") || p.endsWith(".gif"))
    return "image";
  if (p.endsWith(".docx")) return "docx";
  return "file";
};

const item = (label, path, extra = {}) => ({ label, path, type: extToType(path), ...extra });

export const normalizeMaterialLocale = (locale = "ca") =>
  String(locale || "ca").toLowerCase().startsWith("es") ? "es" : "ca";

export const normalizeCatalogLocale = (locale = "ca") => {
  const value = String(locale || "ca").toLowerCase();
  if (value.startsWith("es")) return "es";
  if (value.startsWith("en")) return "en";
  return "ca";
};

const localizeItem = (catalogItem, locale) => {
  const materialLocale = normalizeMaterialLocale(locale);
  const catalogLocale = normalizeCatalogLocale(locale);
  const path = catalogItem.pathsByLocale?.[materialLocale] || catalogItem.path;
  const label = catalogItem.labelsByLocale?.[catalogLocale] || catalogItem.label;
  return { ...catalogItem, label, path, type: extToType(path) };
};

export const standalone = [
  item(
    "Guia didàctica completa (DOCX)",
    "/dossier/Material professorat/GUIA DIDÀCTICA COMPLETA/Dossier professorat 3.docx"
  ),
];

export const blocks = [
  {
    slug: "bloc-0",
    title: "Bloc 0",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 1 (PDF)",
            "/dossier/Material professorat/Bloc 0/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 1.pdf"
          ),
          item(
            "Formació STEAMcat SESSIÓ 2 (PDF)",
            "/dossier/Material professorat/Bloc 0/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 2.pdf"
          ),
        ],
      },

      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 1: El mètode científic (DOCX)",
            "/dossier/Material professorat/Bloc 0/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 1_ El mètode científic.docx"
          ),
          item(
            "Sessió 2: Hipòtesi inicial del projecte (DOCX)",
            "/dossier/Material professorat/Bloc 0/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 2_ Hipòtesi inicial del projecte.docx"
          ),
          item(
            "Sessió 3: La ciència ciutadana (DOCX)",
            "/dossier/Material professorat/Bloc 0/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 3_ La ciència ciutadana.docx"
          ),
          item(
            "Sessió 4: Temperatura ambiental i terrestre (DOCX)",
            "/dossier/Material professorat/Bloc 0/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 4_ Temperatura ambiental i terrestre.docx"
          ),
          item(
            "Sessió 5: La mitjana (DOCX)",
            "/dossier/Material professorat/Bloc 0/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 5_ La mitjana.docx"
          ),
          item(
            "Sessió 6: El perímetre i l’àrea (DOCX)",
            "/dossier/Material professorat/Bloc 0/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 6_ El perímetre i l’àrea.docx"
          ),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 1 (PDF)", "/dossier/Material professorat/Bloc 0/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 1.pdf"),
    item("Rúbriques sessió 2 (PDF)", "/dossier/Material professorat/Bloc 0/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 2.pdf"),
    item("Rúbriques sessió 3 (PDF)", "/dossier/Material professorat/Bloc 0/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 3.pdf"),
    item("Rúbriques sessió 4 (PDF)", "/dossier/Material professorat/Bloc 0/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 4.pdf"),
    item("Rúbriques sessió 5 (PDF)", "/dossier/Material professorat/Bloc 0/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 5.pdf"),
    item("Rúbriques sessió 6 (PDF)", "/dossier/Material professorat/Bloc 0/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 6.pdf"),
  ],
},

      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 0/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 mètode científic (PDF)", "/dossier/Material professorat/Bloc 0/3 MATERIAL ALUMNAT/2 mètode científic.pdf"),
          item("3 ciència ciutadana (PDF)", "/dossier/Material professorat/Bloc 0/3 MATERIAL ALUMNAT/3 ciència ciutadana.pdf"),
          item("4 temperatura (PDF)", "/dossier/Material professorat/Bloc 0/3 MATERIAL ALUMNAT/4 temperatura.pdf"),
          item("5 mitjana (PDF)", "/dossier/Material professorat/Bloc 0/3 MATERIAL ALUMNAT/5 mitjana.pdf"),
          item("6 perímetre (PDF)", "/dossier/Material professorat/Bloc 0/3 MATERIAL ALUMNAT/6 perímetre.pdf"),
        ],
      },
    ],
  },
  {
    slug: "bloc-1-tipus-de-sol",
    title: "Bloc 1: Tipus de sòl",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 3 (PDF)",
            "/dossier/Material professorat/Bloc 1_ Tipus de sòl/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 3.pdf"
          ),
        ],
      },

      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 7: Descobrim el sòl (DOCX)",
            "/dossier/Material professorat/Bloc 1_ Tipus de sòl/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 7_ Descobrim el sòl.docx"
          ),
          item(
            "Sessió 8: Els tipus de sòl (DOCX)",
            "/dossier/Material professorat/Bloc 1_ Tipus de sòl/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 8_ Els tipus de sòl.docx"
          ),
          item(
            "Sessió 9: El pH del sòl (DOCX)",
            "/dossier/Material professorat/Bloc 1_ Tipus de sòl/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 9_ El pH del sòl.docx"
          ),
        ],
      },
{
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 7 (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 7.pdf"),
    item("Rúbriques sessió 8 (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 8.pdf"),
    item("Rúbriques sessió 9 (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 9.pdf"),
  ],
},
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 què és sòl (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/3 MATERIAL ALUMNAT/2 què és sòl.pdf"),
          item("3 secrets del sòl (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/3 MATERIAL ALUMNAT/3 secrets del sòl.pdf"),
          item("4 ph del sòl (PDF)", "/dossier/Material professorat/Bloc 1_ Tipus de sòl/3 MATERIAL ALUMNAT/4 ph del sòl.pdf"),
        ],
      },
    ],
  },
  {
    slug: "bloc-2-vegetacio",
    title: "Bloc 2: Vegetació",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 4 (PDF)",
            "/dossier/Material professorat/Bloc 2_ Vegetació/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 4.pdf"
          ),
        ],
      },
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 10: Tipus de vegetació del sòl (DOCX)",
            "/dossier/Material professorat/Bloc 2_ Vegetació/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 10_ Tipus de vegetació del sòl.docx"
          ),
          item(
            "Sessió 11: Tipus d’arbres (DOCX)",
            "/dossier/Material professorat/Bloc 2_ Vegetació/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 11_ Tipus d’arbres.docx"
          ),
          item(
            "Sessió 12: Restes orgàniques (DOCX)",
            "/dossier/Material professorat/Bloc 2_ Vegetació/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 12_ Restes orgàniques.docx"
          ),
        ],
      },
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 Vegetació del sòl (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/3 MATERIAL ALUMNAT/2 Vegetació del sòl.pdf"),
          item("3 arbres (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/3 MATERIAL ALUMNAT/3 arbres.pdf"),
          item("4 restes orgàniques (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/3 MATERIAL ALUMNAT/4 restes orgàniques.pdf"),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 10 (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 10.pdf"),
    item("Rúbriques sessió 11 (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 11.pdf"),
    item("Rúbriques sessió 12 (PDF)", "/dossier/Material professorat/Bloc 2_ Vegetació/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 12.pdf"),
  ],
},
    ],
  },
  {
    slug: "bloc-3-pedres-roques-i-minerals",
    title: "Bloc 3: Pedres roques i minerals",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 3 (PDF)",
            "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 3.pdf"
          ),
        ],
      },
      
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 13: Les roques (DOCX)",
            "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 13_ Les roques.docx"
          ),
          item(
            "Sessió 14: Els minerals del sòl (DOCX)",
            "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 14_ Els minerals del sòl.docx"
          ),
        ],
      },
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 roques (PDF)", "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/3 MATERIAL ALUMNAT/2 roques.pdf"),
          item("3 minerals (PDF)", "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/3 MATERIAL ALUMNAT/3 minerals.pdf"),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 13 (PDF)", "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 13.pdf"),
    item("Rúbriques sessió 14 (PDF)", "/dossier/Material professorat/Bloc 3_ Pedres roques i minerals/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 14.pdf"),
  ],
},
    ],
  },
  {
    slug: "bloc-4-animals-petits-i-insectes",
    title: "Bloc 4: Animals petits i insectes",
    categories: [
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 15: Animals petits i insectes del sòl (DOCX)",
            "/dossier/Material professorat/Bloc 4_ Animals petits i insectes/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 15_ Animals petits i insectes del sòl.docx"
          ),
        ],
      },
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 4_ Animals petits i insectes/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 animals petits o insectes (PDF)", "/dossier/Material professorat/Bloc 4_ Animals petits i insectes/3 MATERIAL ALUMNAT/2 animals petits o insectes.pdf"),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 15 (PDF)", "/dossier/Material professorat/Bloc 4_ Animals petits i insectes/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 15.pdf"),
  ],
},
    ],
  },
  {
    slug: "bloc-5-residus",
    title: "Bloc 5: Residus",
    categories: [
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 16: Residus i sostenibilitat (DOCX)",
            "/dossier/Material professorat/Bloc 5_ Residus/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 16_ Residus i sostenibilitat.docx"
          ),
        ],
      },
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 5_ Residus/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 Residus (PDF)", "/dossier/Material professorat/Bloc 5_ Residus/3 MATERIAL ALUMNAT/2 Residus.pdf"),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 16 (PDF)", "/dossier/Material professorat/Bloc 5_ Residus/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 16.pdf"),
  ],
},
    ],
  },
  {
    slug: "bloc-6-microrganismes",
    title: "Bloc 6: Microrganismes",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 5 (PDF)",
            "/dossier/Material professorat/Bloc 6_ Microrganismes/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 5.pdf"
          ),
        ],
      },
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 17: Fongs i líquens (DOCX)",
            "/dossier/Material professorat/Bloc 6_ Microrganismes/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 17_ Fongs i líquens.docx"
          ),
          item(
            "Sessió 18: Bacteris del sòl (DOCX)",
            "/dossier/Material professorat/Bloc 6_ Microrganismes/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 18_ Bacteris del sòl.docx"
          ),
        ],
      },
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 6_ Microrganismes/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 fongs i líquens (PDF)", "/dossier/Material professorat/Bloc 6_ Microrganismes/3 MATERIAL ALUMNAT/2 fongs i líquens.pdf"),
          item("3 bacteris (PDF)", "/dossier/Material professorat/Bloc 6_ Microrganismes/3 MATERIAL ALUMNAT/3 bacteris.pdf"),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 17 (PDF)", "/dossier/Material professorat/Bloc 6_ Microrganismes/5 RÚBRIQUES AVALUACIÓ/Rúbrica sessió 17.pdf"),
    item("Rúbriques sessió 18 (PDF)", "/dossier/Material professorat/Bloc 6_ Microrganismes/5 RÚBRIQUES AVALUACIÓ/Rúbrica sessió 18.pdf"),
  ],
},
    ],
  },
  {
    slug: "bloc-7-aigua",
    title: "Bloc 7: Aigua",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 6 (PDF)",
            "/dossier/Material professorat/Bloc 7_ Aigua/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 6.pdf"
          ),
        ],
      },
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT",
        items: [
          item(
            "Sessió 19: L’aigua del sòl (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 19_ L’aigua del sòl.docx"
          ),
          item(
            "Sessió 20: La procedència de l’aigua (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 20_ La procedència de l’aigua.docx"
          ),
          item(
            "Sessió 21: El color de l’aigua (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 21_ El color de l’aigua.docx"
          ),
          item(
            "Sessió 22: La temperatura de l’aigua (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 22_ La temperatura de l’aigua.docx"
          ),
          item(
            "Sessió 23: El pH de l’aigua (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 23_ El pH de l’aigua.docx"
          ),
          item(
            "Sessió 24: Petits animals aquàtics (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 24_ Petits animals aquàtics.docx"
          ),
          item(
            "Sessió 25: Plantes aquàtiques (DOCX)",
            "/dossier/Material professorat/Bloc 7_ Aigua/4 GUIA DIDÀCTICA PROFESSORAT/Sessió 25_ Plantes aquàtiques.docx"
          ),
        ],
      },

      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Introducció (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/1 Introducció.pdf"),
          item("2 aigua del sòl (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/2 aigua del sòl.pdf"),
          item("3 procedencia aigua (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/3 procedencia aigua.pdf"),
          item("4 color aigua (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/4 color aigua.pdf"),
          item("5 temperatura aigua (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/5 temperatura aigua.pdf"),
          item("6 ph de l_aigua (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/6 ph de l_aigua.pdf"),
          item("7 animals aquàtics (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/7 animals aquàtics.pdf"),
          item("8 plantes aquàtiques (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/3 MATERIAL ALUMNAT/8 plantes aquàtiques.pdf"),
        ],
      },
      {
  title: "5 RÚBRIQUES AVALUACIÓ",
  items: [
    item("Rúbriques sessió 19 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 19.pdf"),
    item("Rúbriques sessió 20 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 20.pdf"),
    item("Rúbriques sessió 21 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 21.pdf"),
    item("Rúbriques sessió 22 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 22.pdf"),
    item("Rúbriques sessió 23 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 23.pdf"),
    item("Rúbriques sessió 24 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 24.pdf"),
    item("Rúbriques sessió 25 (PDF)", "/dossier/Material professorat/Bloc 7_ Aigua/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 25.pdf"),
  ],
},
    ],
  },
  {
    slug: "bloc-8-enginyeria-medioambiental",
    title: "Bloc 8: Enginyeria medioambiental (Projecte Idees Genials)",
    categories: [
      {
        title: "1 CONTINGUTS PREVIS",
        items: [
          item(
            "Formació STEAMcat SESSIÓ 7 (PDF)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/1 CONTINGUTS PREVIS/Formació STEAMcat SESSIÓ 7.pdf"
          ),
        ],
      },
      {
        title: "4 GUIA DIDÀCTICA PROFESSORAT (Projecte)",
        items: [
          item(
            "Fase 1 – Exploració del parc (DOCX)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/4 GUIA DIDÀCTICA PROFESSORAT/Projecte Idees Genials_ Fase 1 – Exploració del parc.docx"
          ),
          item(
            "Fase 2 – Imaginem solucions (DOCX)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/4 GUIA DIDÀCTICA PROFESSORAT/Projecte Idees Genials_ Fase 2 – Imaginem solucions.docx"
          ),
          item(
            "Fase 3 – Investiguem propostes (DOCX)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/4 GUIA DIDÀCTICA PROFESSORAT/Projecte Idees Genials_ Fase 3 – Investiguem per justificar les propostes.docx"
          ),
          item(
            "Fase 4 – Construcció del plànol o maqueta (DOCX)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/4 GUIA DIDÀCTICA PROFESSORAT/Projecte Idees Genials_ Fase 4 – Construcció del plànol o maqueta.docx"
          ),
          item(
            "Fase 5 – Presentem el projecte (DOCX)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/4 GUIA DIDÀCTICA PROFESSORAT/Projecte Idees Genials_ Fase 5 – Presentem el projecte i inspirem la comunitat.docx"
          ),
          item(
            "Fase 6 – Reflexió final (DOCX)",
            "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/4 GUIA DIDÀCTICA PROFESSORAT/Projecte Idees Genials_ Fase 6 – Reflexió final.docx"
          ),
        ],
      },
      {
        title: "3 MATERIAL ALUMNAT",
        items: [
          item("1 Challenge (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/1 Challenge.pdf"),
          item("2 projecte introducció (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/2 projecte introducció.pdf"),
          item("3 projecte fase1 (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/3 projecte fase1.pdf"),
          item("4 projecte fase2 (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/4 projecte fase2.pdf"),
          item("5 projecte fase3 (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/5 projecte fase3.pdf"),
          item("6 projecte fase4 (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/6 projecte fase4.pdf"),
          item("7 projecte fase 5 (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/7 projecte fase 5.pdf"),
          item("8 projecte fase6 (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/8 projecte fase6.pdf"),
          item("9 Enhorabona (PDF)", "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/3 MATERIAL ALUMNAT/9 Enhorabona.pdf"),
        ],
      },
       {
      title: "5 RÚBRIQUES AVALUACIÓ",
      items: [
        item(
          "Rúbriques sessió 26 (PDF)",
          "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 26.pdf"
        ),
        item(
          "Rúbriques sessió 27 (PDF)",
          "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 27.pdf"
        ),
        item(
          "Rúbriques sessió 28 (PDF)",
          "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 28.pdf"
        ),
        item(
          "Rúbriques sessió 29 (PDF)",
          "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 29.pdf"
        ),
        item(
          "Rúbriques sessió 30 (PDF)",
          "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 30.pdf"
        ),
        item(
          "Rúbriques sessió 31 (PDF)",
          "/dossier/Material professorat/Bloc 8_ Enginyeria medioambiental/5 RÚBRIQUES AVALUACIÓ/Rúbriques sessió 31.pdf"
        ),
      ],
    },

    ],
  },
];

export const standardDossierCatalog = { standalone, blocks };

export const expressStandalone = [
  item(
    "Dossier de l’alumnat de LivingSoils Express",
    "/dossier/LivingSoils Express/LivingSoils Express Dossier alumnat.pdf",
    {
      resourceKey: "studentDossier",
      labelsByLocale: {
        es: "Dossier del alumnado (ES)",
        en: "Student dossier (CA)",
      },
      pathsByLocale: {
        es: "/dossier/LivingSoils Express/LivingSoils Express Dossier alumnado.pdf",
      },
    }
  ),
];

const expressSession = (id) => ({
  id: String(id),
  title: `Sessió ${id}`,
  resources: [
    item(
      "Guia didàctica",
      `/dossier/LivingSoils Express/Material professorat/sessio_${id}/Guia didàctica LivingSoils Express Sessió ${id}.pdf`,
      {
        resourceKey: "teacherGuide",
        labelsByLocale: {
          es: "Guía didáctica (CA)",
          en: "Teacher guide (CA)",
        },
      }
    ),
    item(
      "Material de la sessió",
      `/dossier/LivingSoils Express/Material professorat/sessio_${id}/LivingSoils Express Sessió ${id}.pdf`,
      {
        resourceKey: "mainSessionMaterial",
        labelsByLocale: {
          es: "Material de la sesión (ES)",
          en: "Session material (CA)",
        },
        pathsByLocale: {
          es: `/dossier/LivingSoils Express/Material professorat/sessio_${id}/LivingSoils Express Versión lengua castellana Sesión ${id}.pdf`,
        },
      }
    ),
    item(
      "Rúbriques d'avaluació",
      `/dossier/LivingSoils Express/Material professorat/sessio_${id}/Rubriques_avaluacio_LivingSoils_Express_sessió${id}.pdf`,
      {
        resourceKey: "assessmentRubrics",
        labelsByLocale: {
          es: "Rúbricas de evaluación (CA)",
          en: "Assessment rubrics (CA)",
        },
      }
    ),
  ],
});

export const expressTeacherSessions = [1, 2, 3, 4, 5].map(expressSession);

export const expressDossierCatalog = {
  standalone: expressStandalone,
  blocks: [],
  sessions: expressTeacherSessions,
};

export const dossierCatalogs = {
  [DOSSIER_MODES.STANDARD]: standardDossierCatalog,
  [DOSSIER_MODES.EXPRESS]: expressDossierCatalog,
};

export const getDossierCatalog = (mode = DOSSIER_MODES.STANDARD, locale = "ca") => {
  const dossierMode = normalizeDossierMode(mode);
  if (dossierMode !== DOSSIER_MODES.EXPRESS) {
    return dossierCatalogs[dossierMode] || standardDossierCatalog;
  }

  if (normalizeCatalogLocale(locale) === "ca") {
    return expressDossierCatalog;
  }

  return {
    standalone: expressStandalone.map((standaloneItem) => localizeItem(standaloneItem, locale)),
    blocks: [],
    sessions: expressTeacherSessions.map((session) => ({
      ...session,
      resources: (session.resources || []).map((resource) => localizeItem(resource, locale)),
    })),
  };
};

export default standardDossierCatalog;
